import { Checkbox, Select, Text, Tooltip, Modal, Button } from '@mantine/core';
import { IconBell, IconEdit, IconEye, IconPencil, IconAlertCircle } from '@tabler/icons-react';
import _, { size } from 'lodash';
import React, { useMemo, useState } from 'react';
import { BASE_URL } from '../api/EndPoints';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import './ProductGrid.css';
import { useLocation } from 'react-router-dom';

const ProductGrid = ({
    data,
    column,
    editVariant,
    isLoading,
    map,
    activeTab,
    isError,
    handleSearchChange,
    onPaginationChange,
    pagination,
    manualPagination,
    rowCount,
    searchTerm,
    status,
    setStatus,
    selectedPairs = [],
    areAllSelected = false,
    handleSelectPair = () => { },
    handleSelectAllPairs = () => { },
    swatchFilter,
    setSwatchFilter,
    countAll,
    countRequested,
    countNotRequested
}) => {

    console.log(activeTab, "mkkm")
    const pimId = data?.[0]?.pimId;
    const [viewReasonModalOpened, setViewReasonModalOpened] = useState(false);
    const [selectedReason, setSelectedReason] = useState('');
    const columns = useMemo(() => {
        const baseColumns = [{
            header: 'S.No',
            size: 50,
            Cell: ({ row }) => <>{row.index + 1}</>
        },

        {
            accessorKey: 'product.image',
            header: 'Image',
            size: 110,
            enableSorting: false,
            enableColumnDragging: false,
            Cell: ({ row }) => {
                const image = row?.original?.vendorImages?.[0]
                return (
                    <div style={{ width: '50px', height: '50px', backgroundColor: 'var(--hs-color-bg-neutral-edge)', borderRadius: '5px', display: 'flex', alignItems: 'center' }}  >
                        {image && image !== 'null' ? (
                            <img src={`${BASE_URL}${image?.replace("/api", "")}?time=${Date?.now()}`} alt="Uploaded Badge" style={{ maxWidth: '50px', maxHeight: '50px' }} />
                        ) : <span style={{ fontSize: 'smaller' }}>No image</span>}
                    </div>
                );
            }
        },

        {
            accessorKey: 'createdDate',
            header: 'Created Date',
            size: 120,
            Cell: ({ row }) => {
                const timestamp = pimId
                    ? row.original.product?.createdDate
                    : row.original.createdDate;
                return timestamp
                    ? new Date(Number(timestamp)).toLocaleDateString('en-GB')
                    : 'N/A';
            },
        },
        {
            accessorKey: 'vendorProductCode',
            header: 'Vendor Product Code',
            size: 120,
            Cell: ({ row }) => (
                <span>
                    {pimId ? row.original.product?.vendorProductCode : row.original.vendorProductCode}
                </span>
            ),
        },
        {
            accessorKey: 'vendorProductName',
            header: 'Vendor Product Name',
            size: 200,
            Cell: ({ row }) => {
                return (
                    <Text lineClamp={1} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                        {row.original.vendorProductName}
                    </Text>
                );
            },
        },

        ...(activeTab === 'Rejected'
            ? [
                {
                    accessorKey: 'rejectedReason',
                    header: 'Rejected Reason',
                    size: 200,
                    Cell: ({ row }) => (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            {row.original.rejectedReason && (
                                <IconEye
                                    onClick={() => {
                                        setSelectedReason(row.original.rejectedReason);
                                        setViewReasonModalOpened(true);
                                    }}
                                    style={{ cursor: 'pointer', color: 'teal' }}
                                    size={18}
                                />
                            )}
                        </div>
                    ),
                },
            ]
            : []),

        {
            accessorKey: 'stockType',
            header: 'Stock Type',
            size: 140,
            Cell: ({ row }) => {
                const item = row.original;
                const isVendor = item.vendorReadyStock || item.vendorProductInfo?.vendorReadyStock || item.stockType === "Vendor Stock" || item.stockType === "vendorReadyStock";
                const isOrder = item.orderDriven || item.vendorProductInfo?.orderDriven || item.stockType === "Made To Order" || item.stockType === "orderDriven";
                const isReady = item.readyStock || item.vendorProductInfo?.readyStock || item.stockType === "Ready Stock" || item.stockType === "readyStock";
                const label = isVendor ? "Ready Stock" : isOrder ? "Made To Order" : isReady ? "Ready Stock" : "-";
                const badgeStyle = isVendor
                    ? { color: '#1d4ed8', backgroundColor: '#dbeafe', border: '1px solid #93c5fd' }
                    : isOrder
                        ? { color: '#92400e', backgroundColor: '#fef3c7', border: '1px solid #fcd34d' }
                        : isReady
                            ? { color: '#15803d', backgroundColor: '#dcfce7', border: '1px solid #86efac' }
                            : { color: '#6b7280', backgroundColor: '#f3f4f6', border: '1px solid #d1d5db' };
                return (
                    <span style={{
                        ...badgeStyle,
                        padding: '3px 10px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: 700,
                        letterSpacing: '0.3px',
                        whiteSpace: 'nowrap',
                        display: 'inline-block'
                    }}>
                        {label}
                    </span>
                );
            },
        },

        ];
        baseColumns.push({
            header: map ? (
                <Checkbox checked={areAllSelected} onChange={() => handleSelectAllPairs(data)} />
            ) : pimId ? 'Action' : 'Actions',
            enableSorting: false,
            enableColumnDragging: false,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            size: 50,
            Cell: ({ row }) => {
                return map ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Checkbox
                            checked={selectedPairs.includes(row.original.productId)}
                            onChange={() => handleSelectPair(row.original)}
                        />
                    </div>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <IconEdit size={18}
                            onClick={() => editVariant(row.original)}
                            style={{ cursor: 'pointer', color: '#0000000DE' }}
                        />
                    </div>
                );
            },
        });

        return baseColumns;
    }, [pimId, map, areAllSelected, selectedPairs, data, activeTab]);

    const renderDetailPanel = ({ row }) => {
        const variants = pimId
            ? row.original.product?.productVariants
            : row.original.productVariants || [];
        const productName = pimId
            ? row.original.product?.vendorProductName
            : row.original.vendorProductName;
        if (!row.original.productVariants?.length > 0) {
            return null;
        }

        return (
            <div className="variant-detail-panel">
                <p className="variant-count">Total Variants: {variants.length}</p>
                {variants.length > 0 ? (
                    <div className="variant-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Variant SKU</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {variants.map((variant, index) => (
                                    <tr key={index}>
                                        <td>{variant.variantSku || 'N/A'}</td>
                                        <td>
                                            {variant.name || 'N/A'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="no-variants">No variants available</p>
                )}
            </div>
        );
    };

    const finalPageCount = useMemo(() => {
        return (rowCount && pagination.pageSize
            ? Math.ceil(rowCount / pagination.pageSize)
            : 1);
    }, [rowCount, pagination.pageSize]);

    const table = useMaterialReactTable({
        columns: column || columns,
        data: data || [],
        manualPagination: true,
        rowCount,
        pageCount: finalPageCount,
        onPaginationChange,
        enableGlobalFilter: false,
        state: {
            pagination,
            isLoading,
            showAlertBanner: isError,
        },
        renderDetailPanel,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        enableHiding: false,
        enableSorting: true,
        defaultColumn: {
            muiTableHeadCellProps: {
                align: 'center',
                className: 'table-header-cell',
            },
            muiTableBodyCellProps: {
                align: 'center',
                className: 'table-body-cell',
            },
        },
        muiTableHeadCellProps: {
            align: 'center',
            className: 'table-header-cell',
        },
        muiTableBodyRowProps: () => ({}),
        muiTableBodyCellProps: ({ row }) => {
            const isSwatchRequested = row.original.swatchRequest === true || row.original.vendorProductInfo?.swatchRequest === true;
            const isSwatchSent = row.original.swatchSent === true || row.original.vendorProductInfo?.swatchSent === true;
            const showWarning = isSwatchRequested && !isSwatchSent;

            return {
                align: 'center',
                className: showWarning ? 'table-body-cell warning-row' : 'table-body-cell',
                sx: showWarning ? {
                    backgroundColor: '#d3ebfcff !important',
                } : {}
            };
        },
        mantineTableProps: {
            className: 'product-grid-table',
        },
        mantinePaginationProps: {
            className: 'pagination-bar',
            showRowsPerPage: false,
            showQuickJumper: false,
            showEllipsis: true,
        },
        renderTopToolbarCustomActions: () => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'flex-end', width: '100%' }}>
                {(activeTab === 'Request Info' || activeTab === 'Draft') && (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#73b7efff', fontSize: '14px', fontWeight: 600 }}>
                            <div style={{ width: '20px', height: '14px', backgroundColor: '#7fbef1ff', border: '0.5px solid #7fbef1ff', borderRadius: '2px' }}></div>
                            <span style={{ display: 'flex', alignItems: 'center' }} >Swatch requested please send swatch..</span>
                        </div>
                        <Select
                            placeholder="Filter Swatch Requested"
                            value={swatchFilter}
                            onChange={(val) => {
                                setSwatchFilter?.(val || '');
                                if (onPaginationChange) {
                                    onPaginationChange({ pageIndex: 0, pageSize: pagination?.pageSize || 5 });
                                }
                            }}
                            data={[
                                { label: `All (${countAll || 0})`, value: '' },
                                { label: `Swatch Requested (${countRequested || 0})`, value: 'true' },
                                { label: `Swatch Not Requested (${countNotRequested || 0})`, value: 'false' },
                            ]}
                            clearable
                            style={{ width: '240px' }}
                        />
                    </>
                )}
                <div
                    className="search-barr-container"
                    style={{ display: 'flex', justifyContent: 'flex-end', position: 'relative', width: '250px' }}
                >
                    <input
                        placeholder="Search Products"
                        value={searchTerm}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        style={{
                            borderRadius: 8,
                            border: '1px solid rgba(0,0,0,0.12)',
                            padding: '8px 35px 8px 10px',
                            width: '100%',
                        }}
                    />

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16" height="16"
                        fill="gray"
                        style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
                        viewBox="0 0 24 24"
                    >
                        <path d="M21 20l-5.6-5.6A7.9 7.9 0 0016 9a8 8 0 10-8 8 7.9 7.9 0 005.4-2.1L20 21l1-1zM4 9a5 5 0 1110 0A5 5 0 014 9z" />
                    </svg>
                </div>
            </div>
        ),
        paginateExpandedRows: false,
    });

    return (
        <div className="product-grid-container">
            <MaterialReactTable table={table} />
            <Modal
                opened={viewReasonModalOpened}
                onClose={() => {
                    setViewReasonModalOpened(false);
                    setSelectedReason('');
                }}
                title="Rejection Reason"
                centered
                transitionProps={{ duration: 0 }}
            >
                <div style={{ padding: '10px' }}>
                    <p style={{ fontSize: '15px', color: '#555', wordBreak: 'break-word', lineHeight: '1.6' }}>
                        {selectedReason}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            onClick={() => {
                                setViewReasonModalOpened(false);
                                setSelectedReason('');
                            }}
                            color="green"
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ProductGrid;
